module.exports = __webpack_public_path__ + "static/img/WechatIMG212.9a17d28.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/WechatIMG212.jpeg
// module id = i7rM
// module chunks = 13